module.exports = __webpack_public_path__ + "img/neutral-div.c323b105.svg";